import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { SectionLabel, SectionHeading } from '../components/ui/UI';
export function WherePeriscanFits() {
  return <>
      <PageHero eyebrow="Category Comparison" title="Where Periscan Fits" titleMuted="in Automated Security Validation." description="These companies helped validate the market. Periscan is focused on making continuous validation self-service, evidence-backed, open-source-accelerated, AI-era ready, and priced for continuous use." bg="none" data-id="element-1965" />

      <SectionStage fx="lightning" data-id="element-1966">
        <section className="relative w-full py-32 border-t border-white/5" data-id="element-1967">
          <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1968">
            <SectionLabel number="01" label="The Landscape" className="mb-8" data-id="element-1969" />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1970">
              <div className="lg:col-span-8" data-id="element-1971">
                <SectionHeading size="xl" data-id="element-1972">
                  The category is real.
                  <br data-id="element-1973" />
                  <span className="text-white/40" data-id="element-1974">
                    The buying model is broken.
                  </span>
                </SectionHeading>
              </div>
            </div>
            <div className="mt-12 max-w-3xl text-lg text-white/60 leading-relaxed" data-id="element-1975">
              <p className="mb-6" data-id="element-1976">
                The market includes players like Picus, Pentera, Cymulate,
                Horizon3.ai / NodeZero, XM Cyber, SafeBreach, AttackIQ,
                CyCognito, Tenable, Qualys, Rapid7, and Wiz.
              </p>
              <p data-id="element-1977">
                These companies helped validate the market. Periscan is focused
                on making continuous validation self-service, evidence-backed,
                open-source-accelerated, AI-era ready, and priced for continuous
                use.
              </p>
            </div>
          </div>
        </section>
      </SectionStage>
    </>;
}